import Vue from 'vue';
import Router from 'vue-router';
import home from '@/views/home'
Vue.use(Router);


import oms from './oms';
import backend from './backend'


export default new Router({
  mode: 'history',
  base: '/',
  scrollBehavior: () => ({ y: 0 }),
	routes: [
		{
			path: '/',
      component: home,
      children: process.env.VUE_APP_TYPE=='oms'? oms : backend,
		},
		{
			path: '/login',
      component: resolve => { require(['@/views/login'], resolve); },
		},

    
		
    // {
    //   path: '/school',
    //   component: resolve => { require(['../views/home.vue'], resolve); },
    //   // children: school,
    // },
	]
})
